/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LearningCompetenceTypeEnum,
    LearningCompetenceTypeEnumFromJSON,
    LearningCompetenceTypeEnumFromJSONTyped,
    LearningCompetenceTypeEnumToJSON,
} from './LearningCompetenceTypeEnum';

/**
 * 
 * @export
 * @interface FisaLearningOutcomeDTO
 */
export interface FisaLearningOutcomeDTO {
    /**
     * 
     * @type {string}
     * @memberof FisaLearningOutcomeDTO
     */
    sourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof FisaLearningOutcomeDTO
     */
    identificator?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FisaLearningOutcomeDTO
     */
    description?: string | null;
    /**
     * 
     * @type {LearningCompetenceTypeEnum}
     * @memberof FisaLearningOutcomeDTO
     */
    type?: LearningCompetenceTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FisaLearningOutcomeDTO
     */
    isLocked?: boolean;
}

export function FisaLearningOutcomeDTOFromJSON(json: any): FisaLearningOutcomeDTO {
    return FisaLearningOutcomeDTOFromJSONTyped(json, false);
}

export function FisaLearningOutcomeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FisaLearningOutcomeDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sourceId': !exists(json, 'sourceId') ? undefined : json['sourceId'],
        'identificator': !exists(json, 'identificator') ? undefined : json['identificator'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'type': !exists(json, 'type') ? undefined : LearningCompetenceTypeEnumFromJSON(json['type']),
        'isLocked': !exists(json, 'isLocked') ? undefined : json['isLocked'],
    };
}

export function FisaLearningOutcomeDTOToJSON(value?: FisaLearningOutcomeDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sourceId': value.sourceId,
        'identificator': value.identificator,
        'description': value.description,
        'type': LearningCompetenceTypeEnumToJSON(value.type),
        'isLocked': value.isLocked,
    };
}

